<div class="merchant-verticals-card" data-cy="merchant-verticals-card">
  <div class="merchant-verticals-card-header">
    <h2>Verticals</h2>

    <p-button
      *ngIf="mode === 'view'"
      (onClick)="edit()"
      [disabled]="isLoading"
      icon="pi pi-file-edit"
      label="Edit"
      size="large"
      id="edit-merchant-verticals-button"
      data-cy="edit-merchant-verticals"
    ></p-button>
    <div *ngIf="mode === 'edit'" class="merchant-verticals-card-header-edit-actions">
      <p-button
        (onClick)="cancel()"
        [disabled]="isSaving"
        icon="pi pi-ban"
        label="Cancel"
        size="large"
        id="cancel-merchant-verticals-button"
        data-cy="cancel-merchant-verticals"
      ></p-button>
      <p-button
        (onClick)="save()"
        [disabled]="isSaving"
        [loading]="isSaving"
        icon="pi pi-check-square"
        label="Save"
        size="large"
        id="save-merchant-verticals-button"
        data-cy="save-merchant-verticals"
      ></p-button>
    </div>
  </div>

  <div class="merchant-verticals-card-body">
    <div class="merchant-verticals-field">
      <label for="merchant-primary-vertical">Primary Vertical</label>
      <p *ngIf="mode === 'view'" data-cy="merchant-primary-vertical">
        {{ primaryVertical?.Name ?? 'None' }}
      </p>
      <p-dropdown
        *ngIf="mode === 'edit'"
        inputId="merchant-primary-vertical"
        [options]="primaryVerticalOptions"
        optionLabel="Name"
        optionValue="VerticalId"
        [(ngModel)]="selectedPrimaryVerticalId"
        (onChange)="onPrimaryVerticalChange($event.value)"
        scrollHeight="400px"
        appendTo="body"
        class="merchant-verticals-dropdown"
        data-cy="merchant-primary-vertical-dropdown"
      ></p-dropdown>
    </div>

    <div class="merchant-verticals-field">
      <label>Subverticals</label>
      <ng-container *ngIf="mode === 'view'">
        <div *ngIf="subVerticals.length > 0" class="merchant-sub-vertical-list" data-cy="merchant-sub-verticals">
          <p *ngFor="let subVertical of subVerticals" data-cy="merchant-sub-vertical">{{ subVertical.Name }}</p>
        </div>
        <p *ngIf="!isLoading && subVerticals.length === 0" data-cy="merchant-sub-verticals-empty">
          No subverticals assigned.
        </p>
      </ng-container>
      <ng-container *ngIf="mode === 'edit'">
        <p-dropdown
          *ngIf="canAddSubVertical"
          [options]="availableSubVerticals"
          optionLabel="Name"
          optionValue="VerticalId"
          [filter]="true"
          filterBy="Name"
          [(ngModel)]="subVerticalToAdd"
          (onChange)="addSubVertical($event.value)"
          placeholder="Add a subvertical"
          appendTo="body"
          class="merchant-verticals-dropdown"
          data-cy="add-merchant-sub-vertical"
        ></p-dropdown>
        <div *ngIf="subVerticals.length > 0" class="merchant-sub-vertical-chips" data-cy="merchant-sub-verticals">
          <p-chip
            *ngFor="let subVertical of subVerticals"
            [label]="subVertical.Name"
            [removable]="true"
            removeIcon="pi pi-times"
            (onRemove)="removeSubVertical(subVertical.VerticalId)"
            data-cy="merchant-sub-vertical-chip"
          ></p-chip>
        </div>
        <small
          *ngIf="subVerticals.length > 0"
          class="merchant-verticals-hint"
          data-cy="merchant-sub-vertical-limit-message"
        >
          Only one subvertical can be chosen from this page. Contact your admin to add more.
        </small>
        <small
          *ngIf="subVerticals.length === 0 && selectedPrimaryVerticalId === null"
          class="merchant-verticals-hint"
          data-cy="merchant-sub-vertical-requires-primary-message"
        >
          Select a primary vertical to choose a subvertical.
        </small>
      </ng-container>
    </div>
  </div>
</div>
